module.exports = __webpack_public_path__ + "static/media/Bikes_2x.5bd0c5cb.jpg";